import React from 'react';
import './AnimatedBackground.css';

function AnimatedBackground() {
    return <div className="animated-background"></div>;
}

export default AnimatedBackground;